(function ($) {
  var DEBUG = true;

  function decodeHtml(str) {
    if (typeof str !== 'string') return str;
    var t = document.createElement('textarea');
    t.innerHTML = str;
    return t.value;
  }
  function norm(u) {
    if (!u) return '';
    u = decodeHtml(u);
    if (u.slice(0,2) === '//') u = window.location.protocol + u;
    return u;
  }

  // (Opcional) Solo bloquear enlaces dentro del bloque de variantes, NO radios
  $(document).on('click', '.product-card-wrapper-with-variants .js-card-variants a', function (e) {
    e.preventDefault();
    e.stopPropagation();
  });

  // Delegación por cambio de radio
  $(document).on('change', '.product-card-wrapper-with-variants .js-card-variant', function () {
    var $radio = $(this);
    var $wrap  = $radio.closest('.product-card-wrapper-with-variants');
    var $card  = $wrap.find('.product-card-wrapper').first();
    if (!$card.length) return;

    // Estos campos con .data() van bien
    var title        = $radio.data('productTitle') || '';
    var url          = $radio.data('productUrl')   || '';
    var available    = $radio.data('productAvailable');
    var badgeOnSale  = $radio.data('badgeOnSale');
    var badgeFinal   = $radio.data('badgeFinalSale');
    var badgeNew     = $radio.data('badgeNew');
    var priceHtml    = $radio.data('priceHtml') || '';

    // ⚠️ Para imágenes y medidas, usar .attr('data-...') para evitar la conversión camelCase con números
    var img165  = norm($radio.attr('data-img-165'));
    var img360  = norm($radio.attr('data-img-360'));
    var img533  = norm($radio.attr('data-img-533'));
    var img720  = norm($radio.attr('data-img-720'));
    var img940  = norm($radio.attr('data-img-940'));
    var img1066 = norm($radio.attr('data-img-1066'));
    var imgW    = $radio.attr('data-img-width');
    var imgH    = $radio.attr('data-img-height');
    var imgAlt  = $radio.attr('data-img-alt');

    if (DEBUG) {
      console.log('[card-variants] change:', { title, url, img533, available, badgeOnSale, badgeFinal, badgeNew });
    }

    // 1) Título + href
    $card.find('.card__heading a.full-unstyled-link').each(function () {
      $(this).text(title);
      if (url) $(this).attr('href', url);
    });

    // 2) Imagen (reemplazo del nodo <img> para forzar repintado)
    (function swapImage() {
      if (!img533) return;
      var $media = $card.find('.card__media .media').first();
      if (!$media.length) return;

      var $oldImg = $media.find('> img').first(); // img principal
      var sizes   = $oldImg.attr('sizes') || '';
      var classes = ($oldImg.attr('class') || '').trim();
      var loading = $oldImg.attr('loading') || 'lazy';

      var srcset = [
        img165  ? (img165  + ' 165w')  : null,
        img360  ? (img360  + ' 360w')  : null,
        img533  ? (img533  + ' 533w')  : null,
        img720  ? (img720  + ' 720w')  : null,
        img940  ? (img940  + ' 940w')  : null,
        img1066 ? (img1066 + ' 1066w') : null
      ].filter(Boolean).join(', ');

      if (DEBUG) console.log('[card-variants] swapping image to', img533);

      var $newImg = $('<img/>', {
        src: img533,
        srcset: srcset,
        sizes: sizes,
        alt: (typeof imgAlt !== 'undefined' && imgAlt !== null) ? imgAlt : ($oldImg.attr('alt') || ''),
        loading: loading
      });

      if (classes) $newImg.attr('class', classes);
      if (imgW) $newImg.attr('width', imgW);
      if (imgH) $newImg.attr('height', imgH);

      if ($oldImg.length) {
        $oldImg.replaceWith($newImg);
      } else {
        $media.prepend($newImg);
      }

      // Si tu tema incluye una imagen secundaria en hover, actualízala también (segunda img)
      var $oldImg2 = $media.find('> img').eq(1);
      if ($oldImg2.length) {
        $oldImg2.attr('src', img533);
        if (srcset) $oldImg2.attr('srcset', srcset);
      }
    })();

    // 3) Precio
    (function swapPrice() {
      var $priceMount = $card.find('.card-information .price').first();
      if (!$priceMount.length || !priceHtml) return;
      var $tmp = $('<div/>').html(priceHtml);
      var $newPrice = $tmp.find('.price').first();
      if ($newPrice.length) $priceMount.replaceWith($newPrice);
    })();

    // 4) Badges
    (function swapBadges() {
      var $badgeCtn = $card.find('.card__badge').first();
      if (!$badgeCtn.length) return;
      $badgeCtn.find('span.badge').remove();
      function addBadge(text) {
        $('<span/>', { 'class':'badge badge--bottom-left', text: text }).appendTo($badgeCtn);
      }
      if (available === false) { addBadge((window.theme?.strings?.soldOut) || 'Sold out'); return; }
      if (badgeFinal) addBadge('FINAL SALE');
      else if (badgeOnSale) addBadge((window.theme?.strings?.onSale) || 'On sale');
      else if (badgeNew) addBadge('NEW');
    })();

    // 5) Quick Add
    (function swapQuickAdd() {
      var $quick = $card.find('.quick-add').first();
      if (!$quick.length) return;
      var $singleVariantInput = $quick.find('input[name="id"]').first();
      var $quickBtn           = $quick.find('button.quick-add__submit').first();
      var $modalOpenerBtn     = $quick.find('modal-opener button.quick-add__submit').first();
      if ($singleVariantInput.length && $quickBtn.length) {
        $quickBtn.prop('disabled', available === false);
      }
      if ($modalOpenerBtn.length && url) {
        $modalOpenerBtn.attr('data-product-url', url);
      }
    })();

    // 6) Estado visual
    (function markSelected() {
      var groupName = $radio.attr('name');
      var $group = $wrap.find('.js-card-variant[name="' + groupName + '"]');
      $group.each(function () {
        var active = this === $radio.get(0);
        $(this).attr('aria-checked', active ? 'true' : 'false');
        $(this).closest('.card-variant__item').toggleClass('is-selected', active);
      });
    })();
  });
})(jQuery);
